const mutations = {
  setResult(state, payload) {
    state.result = {
      ...payload,
      data: payload.data.map((x) => {
        x.hasDetails = true;
        x.expanded = false;
        x.showDocuments = false;
        x.showReferralDocuments = false;
        return x;
      }),
    };
    state.pagination = {
      ...state.pagination,
      totalItemCount: payload.totalItemCount,
      pageCount: payload.pageCount,
      currentPage: payload.currentPage,
      count: payload.count,
    };
  },
  setPagination(state, payload) {
    state.pagination = payload;
  },
  setAdvanceFilter(state, payload) {
    state.advanceFilter = payload;
  },
  setCatalog(state, payload) {
    state.catalog = payload;
  },
  setFilter(state, payload) {
    state.filter = payload;
  },
  setAcademicYears(state, payload) {
    state.catalog.academicYears = payload;
  },
  setResetSelection(state) {
    state.result = {};
    state.pagination = {
      currentPage: 1,
      perPage: 10,
    };
    state.advanceFilter = false;
    state.catalog = {
      academicYears: [],
      caats: [],
      centers: [],
      municipalities: [],
      referralTypes: [],
      schools: [],
      statuses: [],
    };
    state.filter = {
      academicYear: null,
      caat: null,
      center: null,
      municipality: null,
      referredType: null,
      school: null,
      sie: null,
      status: null,
      student: null,
    };
  },
};

export default mutations;
